import constants from "../../config/constants";

const $inject = ['$window', '$scope', '$location', '$routeParams', '$timeout', 'dataService', 'settingsService', 'microApiService', 'dataSourceService', '$rootScope', 'moment'];

const lbaResourceCtrl = function ($window, $scope, $location, $routeParams, $timeout, dataService, settingsService, microApiService, dataSourceService, $rootScope,moment) {
    $timeout(()=> {
        $window.scrollTo(0, 0);
    });

    const vm = this;
    vm.save = save;
    vm.cancel = cancel;
    vm.delete = deleteItem;
    vm.ready = false;
    vm.fields = settingsService.settings.fields;
    vm.deleteConfirm = false;
    vm.cancelConfirm = false;
    vm.itemAdded = false;
    vm.dataService = dataService;
    vm.showCancel = dataService.addNewMode;
    vm.addNew = addNew;
    vm.cancelNew = cancelNew;
    vm.showBack = vm.settings.showBack;// flag to display back button instead of other buttons.
    vm.continueEditing = continueEditing;
    vm.noButtons = vm.settings.noButtons;
    vm.validateAtLeastOneHasValueSet = vm.settings.validateAtLeastOneHasValueSet;
    vm.hasAtLeastOneValueSet = false;
    vm.disableAddNew = disableAddNew;
    vm.isAddNewDisabled = isAddNewDisabled;
    function processData(res) {
        dataService.data.activeItem = res.data;
        vm.ready = true;
    }

    const routeParamId = getRouteParamId();

    function getRouteParamId(){
        let routeId = vm.settings.routeParamId;
        if(!routeId && vm.settings.endpoint !== "Settings"){
            const keys = Object.keys($routeParams).filter(key => key !== 'tab' && key !== 'subtab' && key !== 'removeIndex' && key !== 'removeParamId' && key !== 'dataAt' && key !=='splat' && key !=='path');
            if(keys.length > 0){
                routeId = keys[0];
            }
        }
        return routeId;
    }
    if (vm.settings.microService) {
        dataSourceService.dataSource = constants.DATA_SOURCES.AUTH_ZERO;
        microApiService.get({ endpoint: `${vm.settings.endpoint}/${$routeParams[routeParamId]}`, cb: processData })
    } else {
        if (dataService.addNewMode) {
            dataService.cleanDataOnRouteChange = true;
            vm.activeData = dataService.data.activeItem;
            vm.activeItemCopy = angular.copy(dataService.data.activeItem);
        }

        if ((!dataService.data.activeItem || dataService.refreshDataOnLoad)) {
            if(!vm.settings.endpoint){
                vm.ready = true;
                return;
            }
            dataService.refreshDataOnLoad = false;
            
            dataService.get(vm.settings.endpoint, $routeParams[routeParamId]).then((data) => {
                if (Array.isArray(data)) {
                    dataService.data.activeItem = data[0];
                    $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
                } else {
                    dataService.data.activeItem = data;
                    $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
                    if (!$rootScope.isSaved) {
                        dataService.data.activeItem = JSON.parse(JSON.stringify($rootScope.activeItemData));
                    } else {
                        $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
                        $rootScope.isSaved = false;
                    }
                }

                checkCreditCardToken();

                vm.ready = true;
            });
        } else {
            vm.ready = true;
            if (!$rootScope.isSaved && !$rootScope.isGridItemChanged) {
                dataService.data.activeItem = JSON.parse(JSON.stringify($rootScope.activeItemData));
                $rootScope.isGridItemDeleted = false;
            } else {
                $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
                $rootScope.isSaved = false;
                $rootScope.isGridItemChanged = false;
            }
        }
    }

    function save() {
        if (!vm.resourceForm.$valid) {
            vm.errors = vm.resourceForm.$error.required;
            vm.formErrors = true;

            return false;
        }

        if(vm.validateAtLeastOneHasValueSet && !vm.hasAtLeastOneValueSet){
            $rootScope.$broadcast('lbaToast:showToast', { message: `At least one element needs to be populated`, messageType: 'error' });
            return false;
        }

        const resourceId = vm.settings.endpoint === "Settings" && dataService.data.activeItem
            ? dataService.data.activeItem.Id
            : $routeParams[routeParamId];

        return dataService.patch(vm.settings.endpoint, dataService.data.activeItem, resourceId);
    }

    function cancel() {
        if(!vm.settings.endpoint){
            vm.ready = true;
            return;
        }
        vm.ready = false;

        dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId]).then((data) => {
            if (Array.isArray(data)) {
                dataService.data.activeItem = data[0];
            } else {
                dataService.data.activeItem = data;
            }

            if (dataService.backPath) {
                const pathToNavigate = dataService.backPath;
                dataService.backPath = undefined; 
                $location.path(pathToNavigate);
                return;
            }

            vm.cancelConfirm = false;
            vm.ready = true;
        });
    }

    function deleteItem() {
        if (!vm.deleteConfirm) {
            vm.deleteConfirm = true;
        } else {
            $rootScope.isGridItemChanged = true;
            deleteOnBackend();
        }
    }

    function deleteOnBackend(){
        if(!vm.settings.deleteOnBackend){
            backPath();
            return;
        }

        dataService.delete(vm.settings.endpoint, $routeParams[routeParamId]).then(()=>{
            backPath();
        });
    }

    function addNew() {
        dataService.addNewMode = false;
        dataService.cleanDataOnRouteChange = false;
        vm.showCancel = false;
        vm.itemAdded = true;
        $rootScope.isGridItemChanged = true;
    }
    function continueEditing() {
        vm.itemAdded = false;
        if (vm.settings.continueEditPath) {
            
            let index = $routeParams[vm.settings.removeParamId];
            let itemId = $routeParams[routeParamId];
            let actionPath = vm.settings.continueEditPath(itemId,index,dataService.data.activeItem);
            $location.path(actionPath);
        }
    }

    function cancelNew() {
        // If we're in addNewMode and have a backup, restore it safely
        if (dataService.addNewMode && dataService.addNewBackup) {
            // Ensure dataService.data exists and has proper structure
            if (!dataService.data) {
                dataService.data = { activeItem: undefined, items: [] };
            }
            
            // Restore from backup safely
            if (dataService.addNewBackup.activeItem !== undefined) {
                dataService.data.activeItem = angular.copy(dataService.addNewBackup.activeItem);
            }
            if (dataService.addNewBackup.items) {
                dataService.data.items = angular.copy(dataService.addNewBackup.items);
            }
            
            dataService.addNewMode = false;
            dataService.addNewBackup = undefined;
        }
        backPath();
    }

    function backPath() {
        const newLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

        if (newLookUp.length > 1) {
            newLookUp.pop();
        }

        const data = _.get(dataService.data.activeItem, newLookUp);
        if (data) {
            data.splice($routeParams[vm.settings.removeParamId], 1);
        }

        if (dataService.backPath) {
            const pathToNavigate = dataService.backPath;
            dataService.backPath = undefined; // Clear backPath after using it
            $location.path(pathToNavigate);
        } else {
            const spiltPath = _.split($location.$$path, '/');
            const dropTwoFromPath = _.dropRight(spiltPath, 2);
            const rejoinPath = _.join(dropTwoFromPath, '/');
            $location.path(rejoinPath);
        }
    }

    function checkCreditCardToken(){
        if (vm.settings.endpoint === "CreditCards" && !dataService.data.activeItem.Token)
            {
                vm.ccTokenMissing = true;
            }
    }

    // Returns true if the Add new button should be disabled.
    // If settings.addNewRequiredField is provided (e.g., "Actions.$EnhancedPolicyRulesNewActionsItem.Type"),
    // we resolve it against activeItem and require a truthy value before enabling Add new.
    function disableAddNew() {
        if (!vm.settings || !vm.settings.addNewRequiredField) return false;
        try {
            const lookUp = dataService.spiltDataAt(vm.settings.addNewRequiredField, $routeParams);
            const val = _.get(dataService.data.activeItem, lookUp);
            return !val; // disable when missing
        } catch (e) {
            return false;
        }
    }

    function isAddNewDisabled() {
        return vm.resourceForm.$invalid || vm.disableAddNew();
    }

    $scope.$on("ValidationStatusChanged", (event, args) => {
        const formControl = vm.resourceForm && vm.resourceForm[args["controllerName"]];
        if (!formControl) return;

        if (args.isValid) {
            formControl.$setValidity('customValidation', true);
            if(vm.validateAtLeastOneHasValueSet){
                vm.hasAtLeastOneValueSet = !!args.value;
            }
        } else {
            formControl.$setValidity('customValidation', false);
        }
    });
};

lbaResourceCtrl.$inject = $inject;

export default lbaResourceCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaResource/lbaResourceCtrl.js